import { render, staticRenderFns } from "./flightPassengerList.vue?vue&type=template&id=0bb46e7e&scoped=true&"
import script from "./flightPassengerList.vue?vue&type=script&lang=ts&"
export * from "./flightPassengerList.vue?vue&type=script&lang=ts&"
import style1 from "./flightPassengerList.vue?vue&type=style&index=1&id=0bb46e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb46e7e",
  null
  
)

export default component.exports